<template>
  <div class="text-center">
    <v-dialog
      :value="modalOtpIsOpen"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      transition="dialog-bottom-transition"
      @click:outside="openOtpModal"
      @keydown.esc="openOtpModal"
      width="500"
    >
      <v-card :loading="modalOtpIsLoading">
        <v-toolbar v-if="$vuetify.breakpoint.xsOnly" flat height="90">
          <Logo />
        </v-toolbar>
        <v-card-title v-if="!removeOtpSuccess" class="justify-space-between mb-3" primary-title>
          <span>Está sem aparelho?</span>
          <v-btn
            @click="openOtpModal"
            v-if="$vuetify.breakpoint.smAndUp"
            class="ma-2"
            text
            icon
            color="lighten-2"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="!removeOtpSuccess && !removeOtpFailed" class="otpModalContent">
          <v-form ref="otpForm" lazy-validation>
            <v-text-field
              label="Matrícula"
              placeholder="Insira sua matrícula"
              style="color: #00D318 !important; font-color: black !important;"
              v-model="username"
              :rules="[v => !!v || 'Preencha sua matrícula']"
              outlined
              required
              tabindex="1"
              ref="inputUsername"
            ></v-text-field>
            <v-row justify="start" class="pl-3 mb-5">
              <v-col cols="10" class="pa-0">
                <img :src="captchaImageUrl" width="100%" height="50px" />
              </v-col>
              <v-col cols="2" class="pa-0">
                <v-btn @click="getCaptcha" class="ma-2" text icon color="lighten-2" tabindex="4">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-text-field
              label="Captcha"
              placeholder="Insira o texto do Captcha"
              v-model="captcha"
              style="color: #00D318 !important; font-color: black !important;"
              :rules="[v => !!v || 'Preencha o captcha']"
              outlined
              required
              tabindex="2"
              v-on:keyup.enter="removeOtp"
            ></v-text-field>
            <v-btn
              width="100%"
              class="py-3"
              x-large              
              color="#00D318"
              :disabled="!username || !captcha"
              @click="removeOtp"
              tabindex="3"
            >Solicitar Para não usar o OTP hoje</v-btn>
            <v-btn
              width="100%"
              class="py-3 mt-4"
              x-large
              @click="openOtpModal"
              v-if="$vuetify.breakpoint.xsOnly"
            >Cancelar</v-btn>
          </v-form>
        </v-card-text>
        <!-- SUCESSO  -->
        <v-card-text v-if="removeOtpSuccess" class="otpModalContent">
          <v-icon size="140" color="primary">mdi-check</v-icon>
          <h3>Solicitação realizada com sucesso!</h3>
          <p>Procure o gestor abaixo e peça para que ele aprove sua solicitação pelo aplicativo.</p>
          <p class="gestorName">{{ gestorName }}</p>
          <v-btn
            width="100%"
            class="mt-5"
            depressed
            x-large
            color="primary"
            @click="openOtpModal"
          >Fechar</v-btn>
        </v-card-text>
        <!-- ERRO  -->
        <v-card-text v-if="removeOtpFailed && !removeOtpSuccess" class="otpModalContent">
          <v-icon size="140" color="primary">mdi-close</v-icon>
          <h2>Algo deu errado!</h2>
          <p>Por favor, tente novamente mais tarde.</p>
          <v-btn
            width="100%"
            class="mt-5"
            depressed
            x-large
            color="primary"
            @click="openOtpModal"
          >Fechar</v-btn>
        </v-card-text>

        <v-snackbar v-model="snackbar" multi-line color="error" top>
          {{ snackbarMessage }}
          <v-btn @click="snackbar = false" dark>Close</v-btn>
        </v-snackbar>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AccountService from "../services/account_service";
import Logo from "./Logo";

export default {
  data: () => {
    return {
      removeOtpSuccess: false,
      removeOtpFailed: false,
      gestorName: "",
      username: "",
      captcha: "",
      snackbar: false,
      snackbarMessage: "Ocorreu um erro! Tente novamente mais tarde"
    };
  },
  components: {
    Logo
  },
  computed: {
    ...mapState(["modalOtpIsOpen"]),
    ...mapState(["modalOtpIsLoading"]),
    ...mapState(["captchaImageUrl"])
  },
  methods: {
    ...mapActions(["openOtpModal"]),
    ...mapActions(["loadingOtpModal"]),
    ...mapActions(["getCaptcha"]),
    removeOtp() {
      this.loadingOtpModal();
      setTimeout(() => {
        AccountService.removeHotpTemporarily(this.username, this.captcha)
          .then(response => {
            if (response) {
              this.gestorName = response.result;
              this.loadingOtpModal();
              this.removeOtpSuccess = true;
              this.removeOtpFailed = false;
            }
          })
          .catch(err => {
            if (err) {
              this.snackbar = true;
              this.loadingOtpModal();
              this.getCaptcha();
              if (err.response.data.message) {
                this.snackbarMessage = err.response.data.message;
              }
            }

            if (this.$refs.otpForm) {
              this.$refs.otpForm.reset();
            }
          });
      }, 2000);
    }
  },
  watch: {
    modalOtpIsOpen: function() {
      this.removeOtpFailed = false;
      this.removeOtpSuccess = false;
      if (this.$refs.otpForm) {
        this.$refs.otpForm.reset();
      }
      setTimeout(() => {
        this.$refs.inputUsername.focus();
      }, 10);
    }
  }
};
</script>

<style lang="scss">
.otpModalContent {
  min-height: 315px;
  text-align: center;
}
.gestorName {
  font-weight: 600;
}
</style>
